var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",class:[{'dimmed' : _vm.isDimmed}],attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('main',{staticClass:"site-main",class:{'site-main--fullheight' : _vm.mobileSearchVisible && _vm.portableDevice}},[_c('router-view')],1),_c('MALogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }